import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

const MedicalTools = (props) => {
    logUI("MBHWeb.UI.MedicalTools.ComponentDidMount", new Date(), Tools.getURLPath());
    const serverData = props.serverData;

    return (
        <div className="container-fluid body-content medical-tools-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="page-heading">Medical Tools</h1>
                        </div>
                    </div>

                    <div className="row row-card-eq">

                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-record" src="/images/tool-record.png" />
                                                </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Download My Record</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/medicalrecord" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-access" src="/images/tool-access.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Who's Accessed My Record?</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/audit" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/*<div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img src="/images/tool-trends.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h4>Health Trends</h4>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/trends" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-charts" src="/images/tool-charts.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Growth Charts</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/growthcharts" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-questionnaires" src="/images/tool-questionnaires.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Questionnaires</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/questionnaires" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-track" src="/images/tool-track.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Track My Health</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/trackmyhealth" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="card landing-pg">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="img-container">
                                                <img alt="tool-wallet" src="/images/tool-wallet.png" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <h2>Wallet Card</h2>
                                        </div>
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/walletcard" }}>
                                                SEE MORE
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicalTools;
